import axios from 'axios';
import { Version } from '@Shared/types/version';

export async function getVersion(): Promise<Version> {
  return (await axios.get('/version.json')).data as Version;
}
